/** Bản đồ thế giới M3: 3 khu vực, chạm để di chuyển. */
import { khuDaMo, khuDangMo } from '../../core/khu-vuc.js';
import { gioTrongNgay } from '../../core/khach.js';
import type { GameController } from '../game-controller.js';
import { styleNutChinh, stylePanel, useCapNhat } from '../dung-chung.js';
import { toast } from './Toast.js';

const MAU_KHU: Record<string, string> = {
  'pho-cho': '#c98a2e',
  'bai-bien': '#4aa8de',
  'cho-dem': '#7a5fd0',
};

export function BanDoTheGioi(props: { controller: GameController }) {
  const { controller } = props;
  useCapNhat(controller);
  const { state, duLieu } = controller;
  const gio = gioTrongNgay(state.tongGioGame);

  const bamDen = (ma: string): void => {
    try {
      controller.denKhu(ma);
      toast('Đang đi tới… 🚶');
    } catch (e) {
      toast(e instanceof Error ? e.message : 'Không đi được.');
    }
  };

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>🗺️ Bản đồ thế giới</h3>
      <p style={{ fontSize: '13px', opacity: 0.85, margin: '0 0 8px' }}>
        Giờ game: {gio}h. Chạm vào khu để nhân vật tự đi tới.
      </p>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {duLieu.khuVuc.khuVuc.map((k) => {
          const mo = khuDaMo(state, duLieu).some((x) => x.ma === k.ma);
          const dangO = state.khuHienTai === k.ma;
          const dangMo = khuDangMo(state, duLieu).some((x) => x.ma === k.ma);
          return (
            <div
              key={k.ma}
              style={{
                flex: '1 1 28%',
                minWidth: '140px',
                border: `2px solid ${MAU_KHU[k.ma] ?? '#8a6a3a'}`,
                borderRadius: '10px',
                padding: '10px',
                opacity: mo ? 1 : 0.45,
                background: dangO ? 'rgba(201, 138, 46, 0.15)' : 'transparent',
              }}
            >
              <div style={{ fontWeight: 700 }}>{k.ten}</div>
              <div style={{ fontSize: '12px', opacity: 0.85 }}>
                {mo ? (
                  <>
                    Mở {k.gioMoDau}h–{k.gioMoCuoi}h{dangO ? ' — 📍 đang ở đây' : ''}
                  </>
                ) : (
                  <>Mở ở người chơi cấp {k.capNguoiChoiMo} 🔒</>
                )}
              </div>
              {mo && !dangO && (
                <button
                  style={`${styleNutChinh}margin-top:6px;${dangMo ? '' : 'opacity:0.5;'}`}
                  onClick={() => bamDen(k.ma)}
                  disabled={!dangMo}
                  title={dangMo ? 'Đi tới' : `Đang đóng cửa (mở ${k.gioMoDau}h–${k.gioMoCuoi}h)`}
                >
                  Đi tới
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
